import React, { useEffect, useState } from "react";
import Axios from './../../../utils/api/axiosConf';
import { url } from './../../../utils/api/api';
import { RedNotif, GreenNotif } from './../../../utils/utils';
import { Row, Col, Modal } from "antd";
import { color } from "../../../utils/themes/color";
import TABALE from "./../../../components/table/table";
import INPUT from "./../../../components/input/input";
import TEXTROW from "./../../../components/textRow";
import BUTTON from './../../../components/buttons/button';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';



export default function Inactions() {

    const [loading, setLoading] = useState({ 1: false, 2: false })
    const [data, setData] = useState([]);
    const [page, setPage] = useState({ current: 1, total: 1, pageSize: 5 })
    const [updater, setUpdater] = useState(1);
    const [item, setItem] = useState({ title: "", description: "" })
    const [deletedItem, setDeletedItem] = useState();
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setLoading({ ...loading, 1: true })
        Axios.get(`${url}inactions/search?limit=${page.pageSize}&pageNumber=${page.current}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {

                    setLoading({ ...loading, 1: false })
                    setData(response.data.docs)
                    setPage({
                        ...page,
                        current: response.data.page,
                        total: response.data.totalDocs

                    })
                }
                else {
                    RedNotif(response.message)
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });
    }, [page.current, updater])

    const columns = [
        {
            title: 'نوع وضعیت',
            dataIndex: 'title',
            render: (e) =>
                <div style={{ lineBreak: "anywhere" }}>
                    <p>{e}</p>
                </div>
        },
        {
            title: 'توضیحات',
            dataIndex: 'description',
            render: (e) =>
                <div style={{ lineBreak: "anywhere" }}>
                    <p>{e}</p>
                </div>
        },
        {
            title: 'ویرایش',
            render: (e) => {
                return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div
                        style={{
                            background: color.primary, borderRadius: "5px", paddingTop: "4px",
                            width: "70px", display: 'flex', justifyContent: 'center', alignItems: 'center',
                            height: '25px'
                        }}>
                        <div style={{ cursor: "pointer" }}
                            onClick={() => setItem({ title: e.title, description: e.description, id: e._id })}
                        >  <EditOutlined />  </div>
                        &nbsp;&nbsp;
                        <div style={{ cursor: "pointer" }}
                            onClick={() => {
                                setDeletedItem(e)
                                setShowModal(true)
                            }}
                        >  <DeleteOutlined />  </div>

                    </div>
                </div >
            }


        },

    ];

    const deleteItem = () => {
        Axios.delete(`${url}inactions/delete/${deletedItem._id}`)
            .then(async (response) => {
                if (response.status === 200 || response.status === 201) {
                    setUpdater(updater + 1)
                    GreenNotif(response.message);
                    setItem({ title: "", description: "" })
                    setShowModal(false);
                } else {
                    RedNotif(response.message);
                }
            })
            .catch((error) => {
                RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                console.log("error", error)
            });
    }

    const addItem = () => {
        if (item.title != null && item.title != "") {
            setLoading({ ...loading, 2: true })
            Axios.post(`${url}inactions/create`, item)
                .then(async (response) => {
                    if (response.status === 200 || response.status === 201) {
                        GreenNotif(response.message)
                        setLoading({ ...loading, 2: false })
                        setUpdater(updater + 1)
                        setItem({ title: "", description: "" })
                    } else {
                        RedNotif(response.message);
                        setLoading({ ...loading, 2: false })
                    }
                })
                .catch((error) => {
                    RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                    console.log("error", error)
                    setLoading({ ...loading, 2: false })
                });
        } else {
            RedNotif("عنوان وضعیت غیرکاری نمی تواند خالی باشد")
        }
    }


    const updateItem = () => {
        if (item.title != null && item.title != "") {
            setLoading({ ...loading, 2: true })
            var x = {
                title: item.title,
                description: item.description
            }
            Axios.patch(`${url}inactions/update/${item.id}`, x)
                .then(async (response) => {
                    if (response.status === 200 || response.status === 201) {
                        GreenNotif(response.message)
                         setLoading({ ...loading, 2: false })
                        setUpdater(updater + 1)
                        setItem({ title: "", description: "" })
                    } else {
                        RedNotif(response.message);
                        setLoading({ ...loading, 2: false })

                    }
                })
                .catch((error) => {
                    RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                    console.log("error", error)
                    setLoading({ ...loading, 2: false })

                });
        } else {
            RedNotif("عنوان وضعیت غیرکاری نمی تواند خالی باشد")
        }
    }


    const pager = (p) => {
        if (p != undefined) {
            setPage({ ...page, current: p })
        }
        return page;
    }


    return (
        <>
            <Modal open={showModal} footer={false} onCancel={() => setShowModal(false)}>
                <p>آیا از حذف این وضعیت مطمعن هستید؟</p>
                <Row gutter={20} style={{ marginTop: "25px" }}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <BUTTON text={"خیر"} type={"cancel"} event={() => setShowModal(false)} />
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <BUTTON text={"بله"} type={"submit"} event={() => deleteItem()} />

                    </Col>
                </Row>
            </Modal>
            <Row >
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <div style={{ background: color.onPrimary, width: '100%', height: "40px", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <p style={{ color: "white", fontSize: "18px" }}> وضعیت های غیرکاری</p>
                    </div>
                    <TABALE
                        data={data}
                        columns={columns}
                        page={pager}
                        loading={loading[1]}
                    />
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} style={{ padding: "0 50px" }} value={item.title}>
                    <p> عنوان وضعیت غیرکاری : *</p>
                    <br />
                    <INPUT
                        i={(e) => setItem({ ...item, title: e })}
                        value={item.title} />
                    <br /><br /><br />
                    <p>توضیحات:</p>
                    <br />
                    <TEXTROW
                        i={(e) => setItem({ ...item, description: e })}
                        value={item.description} />
                    <br />  <br />
                    {
                        item.id != null && item.id != undefined
                            ? <BUTTON
                                text={"بروزرسانی وضعیت  "}
                                loading={loading[2]}
                                event={() => updateItem()}
                            />
                            : <BUTTON
                                text={"افزودن وضعیت"}
                                loading={loading[2]}
                                event={() => addItem()}
                            />
                    }
                </Col>
            </Row>
        </>
    )
}